module.exports = __webpack_public_path__ + "media/images/icons/task-d2ff3bfff3298b8cb330cabd8b35a7f1.svg";